export function getAppliedRulesReviewSuggestions(reviewContext, authorizations, authTypes) {
  const updatedById = new Map(authorizations.map(auth => [auth.id, auth]))
  const typesByKey = new Map(authTypes.map(type => [type.key, type]))
  const suggestions = new Map()

  for (const { authorization: previous, associate } of reviewContext) {
    const updated = updatedById.get(previous.id)
    const authType = typesByKey.get(previous.type)
    const before = previous.history?.approved
    const after = updated?.history?.approved

    if (
      !associate?.id ||
      !['initial', 'declined'].includes(previous.status) ||
      previous.resolved_by_associate ||
      updated?.status !== 'accepted' ||
      updated.type !== previous.type ||
      updated.resolved_by_associate ||
      updated.deleted_at ||
      authType?.auth_type !== 'disciplinary' ||
      !Number.isInteger(before) ||
      before < 0 ||
      before >= 4 ||
      !Number.isInteger(after) ||
      after < 4
    ) {
      continue
    }

    const key = `${associate.id}:${previous.type}`
    const existing = suggestions.get(key)
    if (!existing || after > existing.approvedCount) {
      suggestions.set(key, {
        type: previous.type,
        name: authType.name,
        associate,
        approvedCount: after
      })
    }
  }

  return [...suggestions.values()]
}
